const initialState = {
  allContacts: [],
  contactsData: {},
  domainData: {},
  contacts: {},
  shops: [],
  allShops: [],
  contactsShops: [],
};

export const contactsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ALL_CONTACTS":
      return { ...state, allContacts: action.payload };
    case "SET_CONTACTS_DATA":
      return { ...state, contactsData: action.payload };
    case "SET_DOMAIN":
      return { ...state, domainData: action.payload };
    case "SET_CONTACTS":
      return { ...state, contacts: action.payload };
    case "SET_SHOPS":
      return { ...state, shops: action.payload };
    case "SET_ALL_SHOPS":
      return { ...state, allShops: action.payload };
    case "SET_CONTACTS_SHOPS":
      return { ...state, contactsShops: action.payload };
    default:
      return state;
  }
};
